import { useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import KavSection from './Components/KavSection'
import { LINKS, relPath } from '../../../../../Routs/config'
import PalletsSection from './Components/PalletsSection'

const TruckLoading = () => {
    const [date, setDate] = useState<Date>(new Date())
  return (
    <Routes>
        <Route index element={<KavSection date={date} setDate={setDate} />} />
        <Route path={relPath(LINKS.afaca.loading.palletsByID, LINKS.afaca.loading.mainURL)} element={<PalletsSection date={date} />} />
    </Routes>

  )
}

export default TruckLoading
